<template>
  <div class="py-8">
    <header class="mb-8">
      <h2 class="mb-1 text-xl font-light">
        {{
          active_category_id == "all"
            ? "全部商品"
            : category_data.find((item) => item.MenuID == active_category_id)
                .Title
        }}
      </h2>
      <p class="text-sm work_sans text-zinc-400">
        {{ category_product_data.length }} 項商品
      </p>
    </header>
    <div class="mb-8">
      <p class="mb-3 font-medium">搜尋關鍵字</p>

      <TextField
        name="key_word"
        type="text"
        placeholder="關鍵字"
        :value="key_word"
        :show_error="false"
        error_message="請輸入搜尋關鍵字"
        @update-value="$emit('update-keyword', $event)"
      />
    </div>

    <div class="mb-4">
      <router-link
        to="/collections"
        :class="
          active_category_id == 'all'
            ? 'border-secondary text-secondary'
            : 'border-zinc-300'
        "
        class="flex items-center justify-center py-4 mb-3 text-sm transition-all duration-300 border rounded-md hover:text-secondary hover:border-secondary"
      >
        瀏覽全部商品
      </router-link>
    </div>

    <div
      class="mb-8"
      v-for="(menu, menu_index) in menu_category_data"
      :key="`menu_${menu_index}`"
    >
      <p class="mb-3 font-medium">{{ menu.Title }}</p>
      <ol class="mb-2">
        <li
          v-for="(item, item_index) in GetCategoryMenu(menu.MenuCategoryID)"
          :key="`category_${menu_index}_${item_index}`"
        >
          <router-link
            :to="`/collections?category=${item.MenuID}`"
            :class="
              active_category_id == item.MenuID
                ? 'border-secondary text-secondary'
                : 'border-zinc-300'
            "
            class="flex items-center justify-center py-4 mb-3 text-sm transition-all duration-300 border rounded-md hover:text-secondary hover:border-secondary"
          >
            {{ item.Title }}
          </router-link>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import TextField from "@/components/checkout/Form/TextField.vue";
export default {
  name: "ProductCategoryList",
  components: {
    TextField,
  },
  props: {
    menu_category_data: {
      require: true,
      type: Array,
    },
    category_data: {
      require: true,
      type: Array,
    },
    active_category_id: {
      require: true,
      type: String,
    },
    category_product_data: {
      require: true,
      type: Array,
    },
    key_word: {
      require: true,
      type: String,
    },
  },
  methods: {
    GetCategoryMenu(category_id) {
      return this.category_data.filter(
        (item) => item.MenuCategoryID == category_id
      );
    },
  },
};
</script>
